import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  showScrollTop = false;

  constructor() {
  }

  ngOnInit() {
  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    setTimeout(() => {
      const scrollPosition = window.pageYOffset;
      if (scrollPosition >= 100) {
        this.showScrollTop = true;
      } else {
        this.showScrollTop = false;
      }
    }, 1000)

  }

  scrollTop() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

}
